import { IMealPlanTemplate } from "../../types/plan";

export class PlanTemplateDb {
    private dbName = 'PlanTemplateDB';
    private dbVersion = 2;
    private storeName = 'plantemplates';

    async initDB(): Promise<void> {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onerror = () => {
                reject(request.error);
            };

            request.onsuccess = () => {
                resolve();
            };

            request.onupgradeneeded = (event) => {
                const db = (event.target as IDBOpenDBRequest).result;
                if (!db.objectStoreNames.contains(this.storeName)) {
                    const store = db.createObjectStore(this.storeName, { 
                        keyPath: ['household_id', 'template_id', 'user_email', 'weekday', 'meal'],
                    });
                    // Add compound index for user+date+meal
                    store.createIndex('userDateMeal', ['household_id', 'template_id', 'user_email', 'weekday', 'meal'], { unique: true });
                }
            };
        });
    }

    async addPlanTemplates(plans: IMealPlanTemplate[], replace?: boolean): Promise<void> {
        const db = await this.getDB();
        const transaction = db.transaction(this.storeName, 'readwrite');
        const store = transaction.objectStore(this.storeName);

        if (replace) {
            const clearRequest = store.clear();
            clearRequest.onsuccess = () => {
              console.log("cleared plan templates");
            };
          }

        return new Promise((resolve, reject) => {
            plans.forEach(plan => {
                const planToStore = { ...plan, template_id: Number(plan.template_id), household_id: plan.household.id, user_email: plan.user.email };
                store.put(planToStore);
            });

            transaction.oncomplete = () => {
                resolve();
            };

            transaction.onerror = () => {
                reject(transaction.error);
            };
        });
    }

    async getPlanTemplates(): Promise<IMealPlanTemplate[]> {
        const db = await this.getDB();
        const transaction = db.transaction(this.storeName, 'readonly');
        const store = transaction.objectStore(this.storeName);

        return new Promise((resolve, reject) => {
            const request = store.getAll();

            request.onsuccess = () => {
                resolve(request.result);
            };

            request.onerror = () => {
                reject(request.error);
            };
        });
    }

    async getPlanTemplate(filter: Partial<IMealPlanTemplate>): Promise<IMealPlanTemplate | null> {
        const db = await this.getDB();
        const transaction = db.transaction(this.storeName, 'readonly');
        const store = transaction.objectStore(this.storeName);

        return new Promise((resolve, reject) => {
            const request = store.openCursor();

            request.onsuccess = () => {
                const cursor = request.result;
                if (cursor) {
                    const plan = cursor.value as IMealPlanTemplate;
                    const matches = Object.entries(filter).every(
                        ([key, value]) => plan[key as keyof IMealPlanTemplate] === value
                    );

                    if (matches) {
                        resolve(plan);
                        return;
                    }
                    cursor.continue();
                } else {
                    resolve(null);
                }
            };

            request.onerror = () => {
                reject(request.error);
            };
        });
    }

    async updatePlanTemplate(plan: IMealPlanTemplate): Promise<void> {
        const db = await this.getDB();
        const transaction = db.transaction(this.storeName, 'readwrite');
        const store = transaction.objectStore(this.storeName);

        return new Promise((resolve, reject) => {
            // Put will update if exists, create if not
            const planToStore = { ...plan, template_id: Number(plan.template_id), household_id: plan.household.id, user_email: plan.user.email };
            const request = store.put(planToStore);

            request.onsuccess = () => {
                resolve();
            };

            request.onerror = () => {
                reject(request.error);
            };
        });
    }

    // async deletePlanTemplate(plan: IMealPlanTemplate): Promise<void> {
    //     const db = await this.getDB();
    //     const transaction = db.transaction(this.storeName, 'readwrite');
    //     const store = transaction.objectStore(this.storeName);

    //     return new Promise((resolve, reject) => {
    //         const request = store.delete(plan.id);

    //         request.onsuccess = () => {
    //             resolve();
    //         };

    //         request.onerror = () => {
    //             reject(request.error);
    //         };
    //     });
    // }

    private async getDB(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onerror = () => {
                reject(request.error);
            };

            request.onsuccess = () => {
                resolve(request.result);
            };
        });
    }
}